import {
  Box,
  capitalize,
  makeStyles,
  Theme,
  useTheme,
} from '@material-ui/core';
import { cloneElement, FC, ReactElement } from 'react';
import { WbTruncatedTypographyWrapper } from '../WbTruncatedTypographyWrapper';

interface IconLabelBoxProps {
  label: string;
  backgroundColor: string;
  icon?: ReactElement;
  value?: string | number;
}

const useStyles = makeStyles<
  Theme,
  { backgroundColor: string; maxWidth?: string }
>(_ => ({
  defaultBox: {
    display: 'flex',
    gap: '6px',
    width: 'fit-content',
    borderRadius: '4px',
    padding: '6px 8px 6px 6px',
  },

  valueBox: {
    minWidth: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  valueText: {
    fontWeight: 700,
    fontSize: '0.875rem',
  },
}));

export const IconLabelBox: FC<IconLabelBoxProps> = ({
  label,
  icon,
  backgroundColor,
  value,
}) => {
  const classes = useStyles({ backgroundColor });
  const theme = useTheme();

  const textColor = theme.palette.black;

  return (
    <Box className={classes.defaultBox} style={{ backgroundColor }}>
      {icon && (
        <Box className={classes.valueBox}>
          {cloneElement(icon, {
            fontSize: 'small',
            height: '20px',
            width: '20px',
          })}
        </Box>
      )}
      {!icon && value && (
        <Box className={classes.valueBox}>
          <span className={classes.valueText} style={{ color: textColor }}>
            {value}
          </span>
        </Box>
      )}
      <WbTruncatedTypographyWrapper
        maxLines={1}
        value={capitalize(label)}
        enableTooltip={false}
        style={{
          color: textColor,
          fontWeight: '400',
        }}
      />
    </Box>
  );
};
